import type { RosieSessionUserType } from './rosieUserTypes';
import { ROSIE_SESSION_USER_TYPES } from './rosieUserTypes';

/** Aligns with nav "Admins" section: Rosie, Bitwarden, Dropbox audit, email templates */
export const ADMIN_ONLY_USER_TYPES = ['staff', 'super-admin'] as const;

/** Staff routes: all session types except SCLA readers (defense-in-depth if reader hits main tree) */
export const STAFF_USER_TYPES = [
  'staff',
  'super-admin',
  'scla-fellow',
  'admin',
  'user',
  'guest',
] as const;

export type AdminOnlyUserType = (typeof ADMIN_ONLY_USER_TYPES)[number];
export type StaffUserType = (typeof STAFF_USER_TYPES)[number];

export { ROSIE_SESSION_USER_TYPES };
export type { RosieSessionUserType };
